import { Link } from "react-router-dom";
import "./LoginVerification.css";
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer/";
import { useSelector } from "react-redux";
function LoginVerification() {
  const labels = useSelector((state) => state.labels.data);
  return (
    <>
      <Header />

      {/* Login */}
      <section className="login">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="text">
                <ul>
                  <li>
                    <h5>
                      <img src="images/icons/check-circle.svg" alt="" />
                      {labels?.auth?.title1}
                    </h5>
                    <p>{labels?.auth?.desc1}</p>
                  </li>
                  <li>
                    <h5>
                      <img src="images/icons/check-circle.svg" alt="" />
                      {labels?.auth?.title2}
                    </h5>
                    <p>{labels?.auth?.desc2}</p>
                  </li>
                  <li>
                    <h5>
                      <img src="images/icons/check-circle.svg" alt="" />
                      {labels?.auth?.title3}
                    </h5>
                    <p>{labels?.auth?.desc3}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5">
              <form>
                <h4>Login</h4>
                <div className="input-container">
                  <label htmlFor="password">
                    Enter your one time code from your email
                  </label>
                  <input type="password" placeholder="••••••••••" />
                </div>
                <div className="countdown">
                  Time Remaining <div id="countdown" />
                </div>
                <button className="button-style-01">Resend the code </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Login End */}

      <Footer />
    </>
  );
}

export default LoginVerification;
